import {PageContainer} from '@/components/organisms';
import PropTypes from 'prop-types';
import {SectionTitle, TabsComponent} from '@/components/molecules';
import {FONT_SIZE} from '@/utils/constants/globalStyle';
import {DisplayForm} from '@/containers/ClubPlus/CreateTier/phases/Display/Form';
import {useIntl} from 'react-intl';
import {useMemo} from 'react';
import {useAppSelector} from '@/store';
import {selectCountryCode} from '@/store/slices/countryCodeSlice';
import {COUNTRY_LANGUAGES_CODES} from '@/utils/constants/globalConstants';

export const Display = ({tierData}) => {
  const {formatMessage} = useIntl();
  const countryCode = useAppSelector(selectCountryCode);

  const tabLangs = useMemo(() => {
    const languages = COUNTRY_LANGUAGES_CODES[countryCode] || [];

    return languages.map((lang) => ({
      id: lang.code,
      tabLabel: lang.title,
      title: lang.title,
      tabComponent: (
        <DisplayForm key={lang.code} language={lang.code} tierData={tierData} />
      )
    }));
  }, [countryCode, tierData]);

  return (
    <section className='mt-10'>
      <PageContainer>
        <div className='mb-3'>
          <SectionTitle
            fontSize={FONT_SIZE.XXL}
            label={formatMessage({
              id: 'CLUB_PLUS.TIER_CREATE_DISPLAY_SECTION_TITLE'
            })}
          />
        </div>
        <TabsComponent tabList={tabLangs} />
      </PageContainer>
    </section>
  );
};

Display.propTypes = {
  tierData: PropTypes.object.isRequired
};
